exports = module.exports = require("../../../../math-wordproblems/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".operation-fractions-component[data-v-a4e0dc68]{display:flex;align-items:flex-start}.operation-fractions-component .left-hand-operation .operands[data-v-a4e0dc68]{display:flex}.operation-fractions-component .left-hand-operation .operands align-items:center .operand[data-v-a4e0dc68]{display:flex;justify-content:around;align-items:center}.operation-fractions-component .fraction-result[data-v-a4e0dc68]{border:1px solid green;color:#add8e6}.operation-fractions-component .pgcd[data-v-a4e0dc68]{color:#fe3333}", ""]);

// exports
